import React, { useEffect, useState } from 'react';
import * as IoC from 'typescript-ioc';
import { formatTimezoneOffset, getTimezoneOffsetInMinutes } from '../../../../../infrastructure/utils/date-fns-overrides.utils';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';
import { TimeFormats } from '../../../../../infrastructure/date-formatter';
import { NAVIGATION_BAR_CLOCK_INTERVAL } from '../../../../../constants/date-time.constants';

interface IProps {
    timeZone: string;
}


const NavigationBarClock = (props: IProps) => {
    const [currentTime, setCurrentTime] = useState(null);
    const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const {timeZone} = props;
    const timeZoneOffset = formatTimezoneOffset(getTimezoneOffsetInMinutes(timeZone));

    const getCurrentTime = () => {
        const formattedCurrentTime = dateTimeFormatter.dateToFormattedString(
            new Date(),
            TimeFormats.Day12Hours,
            timeZone
        );

        const formatResult = formattedCurrentTime.toLowerCase().replace(' ', '');
        setCurrentTime(formatResult);

        return formatResult;
    };

    const localTimezoneTime = dateTimeFormatter.dateToFormattedString(
        new Date(),
        dateTimeFormatter.getLocalTimeFormat()
    );

    const eventTimezoneTime = dateTimeFormatter.dateToFormattedString(
        new Date(),
        dateTimeFormatter.getLocalTimeFormat(),
        timeZone
    );

    const isEventTimezoneTimeDifferent = localTimezoneTime !== eventTimezoneTime;
    const timeOffsetText = !isEventTimezoneTimeDifferent ? '' : `(GMT ${timeZoneOffset})`;

    useEffect(() => {
        const timerID = setInterval(() => getCurrentTime(), NAVIGATION_BAR_CLOCK_INTERVAL);
        return function cleanup() {
            clearInterval(timerID);
        };
    });

    useEffect(() => {
        setCurrentTime(getCurrentTime());
    }, [timeZone]);

    return (
        currentTime &&
        <div className='navigation-bar__current-time'>
            {`${currentTime} ${timeOffsetText}`}
        </div>
    );
};

export default NavigationBarClock;
